

/**
 * All possible icons available via the `GenericIcon` SCSS.
 */
export enum Icons {
    'Add' = 0,
    'Drop-Off',
    'Lyft',
    'Rental',
    'Shuttle',
    'Enterprise-Shuttle',
    'Uber',
    'Loaner',
    'Waiter',
    'Alert',
    'Appointment',
    'Arrow',
    'Arrow-Back',
    'Business',
    'Calendar',
    'Cart',
    'Checkbox',
    'Checkbox-Selected',
    'Check-In',
    'Close',
    'Complete',
    'CSI',
    'Details',
    'Dropdown',
    'Equity',
    'Fail',
    'Home',
    'Information',
    'Key',
    'License',
    'Menu',
    'No',
    'Phone',
    'Profile',
    'QR',
    'Radio',
    'Radio-Selected',
    'Save',
    'Send',
    'Services-Default',
    'Special',
    'Star-Circle',
    'Success',
    'User',
    'Vehicle',
    'License-Scan-Front',
    'License-Scan-Back',
    'Edit',
    'Warn',
    'Accessibility',
    'Settings',
    'DMS',
    'Text',
    'Email',
    'HarborWarning',
    'X',
    'Plus',
    'Dash',
    'Tow-Truck',
    'Barcode-Line',
    'Pen'
}

/**
 * Transforms the {@link Icons} enumeration into a type of all of the keys from the enumeration.
 *
 * @note
 * This is effectively the same as manually doing:
 * ``` TSX
 * export type IconTypes = 'Add' | 'Drop-Off' | '...' | 'Barcode-Line';
 * ```
 */
export type IconTypes = keyof typeof Icons;

/**
 * Props types definition for the `GenericIcon` component.
 */
export interface GenericIconProps {
    /**
     * Decides what icon to display based on the keys from the {@link Icons} enumeration.
     */
    iconType: IconTypes;
    /**
     * The aria-label for accessibility tools like screen readers.
     */
    ariaLabel?: string;
    /**
     * Alt text for the icon image.
     */
    title?: string;
    /**
     * Whether the image should be ignored by accessibility tools.
     */
    ariaHidden?: boolean;
}